// const functionData = [
//   {
//     label: "Abs",
//     value: 0,
//     codebox: [],
//   },
//   {
//     label: "Divide",
//     value: 1,
//     codebox: [0],
//   },
//   {
//     label: "Ceil",
//     value: 2,
//     codebox: [],
//   },
//   {
//     label: "Floor",
//     value: 3,
//     codebox: [],
//   },
//   {
//     label: "Max",
//     value: 4,
//     codebox: [0],
//   },
//   {
//     label: "Min",
//     value: 5,
//     codebox: [0],
//   },
//   {
//     label: "Modulo",
//     value: 6,
//     codebox: [0],
//   },
//   {
//     label: "Sum",
//     value: 7,
//     codebox: [0],
//   },
//   {
//     label: "ToNumber",
//     value: 8,
//     codebox: [],
//   },
//   {
//     label: "IndexOf",
//     value: 9,
//     codebox: [0],
//   },
//   {
//     label: "NumberToString",
//     value: 10,
//     codebox: [],
//   },
//   {
//     label: "ConvertEmptyStringToNull",
//     value: 11,
//     codebox: [],
//   },
//   {
//     label: "Length",
//     value: 12,
//     codebox: [],
//   },
//   {
//     label: "Split",
//     value: 13,
//     codebox: [0, 1],
//   },
//   {
//     label: "Strip",
//     value: 14,
//     codebox: [0],
//   },
//   {
//     label: "Substring",
//     value: 15,
//     codebox: [0, 1],
//   },
//   {
//     label: "ToLowercase",
//     value: 16,
//     codebox: [],
//   },
//   {
//     label: "ToUppercase",
//     value: 17,
//     codebox: [],
//   },
//   {
//     label: "Trim",
//     value: 18,
//     codebox: [],
//   },
//   {
//     label: "TrimLeading",
//     value: 19,
//     codebox: [],
//   },
//   {
//     label: "TrimTrailing",
//     value: 20,
//     codebox: [],
//   },
//   {
//     label: "Concat",
//     value: 21,
//     codebox: [0],
//   },
//   {
//     label: "DefaultOption",
//     value: 22,
//     codebox: [0],
//   },
//   {
//     label: "Replace",
//     value: 23,
//     codebox: [0, 1],
//   },
//   {
//     label: "ReplaceLookup",
//     value: 24,
//     codebox: [0, 1],
//   },
//   {
//     label: "ToDate",
//     value: 25,
//     codebox: [0],
//   },
//   {
//     label: "StartOfMonth",
//     value: 26,
//     codebox: [],
//   },
//   {
//     label: "EndOfTheMonth",
//     value: 27,
//     codebox: [],
//   },
//   {
//     label: "Today",
//     value: 28,
//     codebox: [],
//   },
//   {
//     label: "ElapsedYear",
//     value: 29,
//     codebox: [0],
//   },
//   {
//     label: "ElapsedMonth",
//     value: 30,
//     codebox: [0],
//   },
//   {
//     label: "ElapsedDay",
//     value: 31,
//     codebox: [0],
//   },
//   {
//     label: "Age",
//     value: 32,
//     codebox: [],
//   },
//   {
//     label: "AgeAsOn",
//     value: 33,
//     codebox: [0],
//   },
// ];

const functionList = [
  {
    name: "Abs",
    displayedName: "Abs",
    dataType: 2,
    numberOfParameters: 0,
    returnDataType: 2,
    parameters: [],
  },
  {
    name: "Divide",
    displayedName: "Divide",
    dataType: 2,
    returnDataType: 2,
    numberOfParameters: 1,
    parameters: [{ id: 1, value: "", name: "divisor", code: "Value" }],
  },
  {
    name: "Round",
    displayedName: "Round",
    dataType: 2,
    returnDataType: 2,
    numberOfParameters: 1,
    parameters: [{ id: 1, value: "", name: "decimals", code: "Value" }],
  },
  {
    name: "PadLeading",
    displayedName: "PadLeading",
    dataType: 1,
    returnDataType: 1,
    numberOfParameters: 2,
    parameters: [
      { id: 1, value: "", name: "number", code: "Length" },
      { id: 2, value: "", name: "number", code: "Value" },
    ],
  },
  {
    name: "PadTrailing",
    displayedName: "PadTrailing",
    dataType: 1,
    returnDataType: 1,
    numberOfParameters: 2,
    parameters: [
      { id: 1, value: "", name: "number", code: "Length" },
      { id: 2, value: "", name: "number", code: "Value" },
    ],
  },
  {
    name: "Ceil",
    displayedName: "Ceil",
    dataType: 2,
    returnDataType: 2,
    numberOfParameters: 0,
    parameters: [],
  },
  {
    name: "Floor",
    displayedName: "Floor",
    dataType: 2,
    returnDataType: 2,
    numberOfParameters: 0,
    parameters: [],
  },
  {
    name: "Max",
    displayedName: "Max",
    dataType: 2,
    returnDataType: 2,
    numberOfParameters: 1,
    parameters: [{ id: 1, value: "", name: "number", code: "Value" }],
  },
  {
    name: "Min",
    displayedName: "Min",
    dataType: 2,
    returnDataType: 2,
    numberOfParameters: 1,
    parameters: [{ id: 1, value: "", name: "number", code: "value" }],
  },
  {
    name: "Modulo",
    displayedName: "Modulo",
    dataType: 2,
    returnDataType: 2,
    numberOfParameters: 1,
    parameters: [{ id: 1, value: "", name: "number", code: "value" }],
  },
  {
    name: "Sum",
    displayedName: "Sum",
    dataType: 2,
    returnDataType: 2,
    numberOfParameters: 1,
    parameters: [{ id: 1, value: "", name: "number", code: "Value" }],
  },
  {
    name: "DecimalToComp2",
    displayedName: "DecimalToComp2",
    dataType: 2,
    returnDataType: 1,
    numberOfParameters: 1,
    parameters: [{ id: 1, value: "", name: "number", code: "Value" }],
  },

  {
    name: "ToNumber",
    displayedName: "ToNumber",
    dataType: 1,
    returnDataType: 2,
    numberOfParameters: 0,
    parameters: [],
  },
  {
    name: "IndexOf",
    displayedName: "IndexOf",
    dataType: 1,
    returnDataType: 2,
    numberOfParameters: 1,
    parameters: [{ id: 1, value: "", name: "string", code: "value" }],
  },
  {
    name: "NumberToString",
    displayedName: "NumberToString",
    dataType: 2,
    returnDataType: 1,
    numberOfParameters: 0,
    parameters: [],
  },

  {
    name: "NotEqual",
    displayedName: "Not",
    dataType: 3,
    returnDataType: 3,
    numberOfParameters: 1,
    parameters: [{ id: 1, value: "", name: "boolean", code: "Value" }],
  },
  {
    name: "Contains",
    displayedName: "Contains",
    dataType: 1,
    returnDataType: 3,
    numberOfParameters: 1,
    parameters: [{ id: 1, value: "", name: "string", code: "Value" }],
  },
  {
    name: "EndsWith",
    displayedName: "EndsWith",
    dataType: 1,
    returnDataType: 3,
    numberOfParameters: 1,
    parameters: [{ id: 1, value: "", name: "string", code: "Value" }],
  },
  {
    name: "IsBlank",
    displayedName: "IsBlank",
    dataType: 1,
    returnDataType: 3,
    numberOfParameters: 0,
    parameters: [],
  },
  {
    name: "IsNull",
    displayedName: "IsNull",
    dataType: 1,
    returnDataType: 3,
    numberOfParameters: 0,
    parameters: [],
  },
  {
    name: "IsNumeric",
    displayedName: "IsNumeric",
    dataType: 1,
    returnDataType: 3,
    numberOfParameters: 0,
    parameters: [],
  },
  {
    name: "StartsWith",
    displayedName: "StartsWith",
    dataType: 1,
    returnDataType: 1,
    numberOfParameters: 1,
    parameters: [{ id: 1, value: "", name: "string", code: "value" }],
  },

  {
    name: "ConvertEmptyStringToNull",
    displayedName: "ConvertEmptyStringToNull",
    returnDataType: 1,
    dataType: 1,
    numberOfParameters: 0,
    parameters: [],
  },
  {
    name: "Length",
    displayedName: "Length",
    dataType: 1,
    returnDataType: 2,
    numberOfParameters: 0,
    parameters: [],
  },
  {
    name: "Match",
    displayedName: "Match",
    dataType: 1,
    returnDataType: 1,
    numberOfParameters: 1,
    parameters: [{ id: 1, value: "", name: "string", code: "Value" }],
  },
  {
    name: "Split",
    displayedName: "Split",
    dataType: 1,
    returnDataType: 1,
    numberOfParameters: 2,
    parameters: [
      { id: 1, value: "", name: "string", code: "Value" },
      { id: 2, value: "", name: "number", code: "Section" },
    ],
  },

  {
    name: "Strip",
    displayedName: "Strip",
    dataType: 1,
    returnDataType: 1,
    numberOfParameters: 1,
    parameters: [{ id: 1, value: "", name: "string", code: "value" }],
  },
  // {
  //   name: "StripNewLine",
  //   displayedName: "StripNewLine",
  //   dataType: 1,
  //   returnDataType: 1,
  //   numberOfParameters: 0,
  //   parameters: [],
  // },

  {
    name: "Substring",
    displayedName: "Substring",
    dataType: 1,
    returnDataType: 1,
    numberOfParameters: 2,
    parameters: [
      { id: 1, value: "", name: "number", code: "start" },
      { id: 2, value: "", name: "number", code: "length" },
    ],
  },
  {
    name: "ToLowercase",
    displayedName: "ToLowerCase",
    dataType: 1,
    returnDataType: 1,
    numberOfParameters: 0,
    parameters: [],
  },
  {
    name: "ToUppercase",
    displayedName: "ToUpperCase",
    dataType: 1,
    returnDataType: 1,
    numberOfParameters: 0,
    parameters: [],
  },
  {
    name: "Trim",
    displayedName: "Trim",
    dataType: 1,
    returnDataType: 1,
    numberOfParameters: 0,
    parameters: [],
  },
  {
    name: "TrimLeading",
    displayedName: "TrimLeading",
    dataType: 1,
    returnDataType: 1,
    numberOfParameters: 0,
    parameters: [],
  },
  {
    name: "TrimTrailing",
    displayedName: "TrimTrailing",
    dataType: 1,
    returnDataType: 1,
    numberOfParameters: 0,
    parameters: [],
  },
  {
    name: "Concat",
    displayedName: "Concat",
    dataType: 1,
    returnDataType: 1,
    numberOfParameters: 1,
    parameters: [{ id: 1, value: "", name: "string", code: "Value" }],
  },
  {
    name: "DefaultOption",
    displayedName: "DefaultOption",
    dataType: 1,
    returnDataType: 1,
    numberOfParameters: 1,
    parameters: [{ id: 1, value: "", name: "string", code: "Value" }],
  },
  {
    name: "Replace",
    displayedName: "Replace",
    dataType: 1,
    returnDataType: 1,
    numberOfParameters: 2,
    parameters: [
      { id: 1, value: "", name: "string", code: "Search Value" },
      { id: 2, value: "", name: "string", code: "New value " },
    ],
  },
  {
    name: "ReplaceLookup",
    displayedName: "ReplaceLookup",
    dataType: 1,
    returnDataType: 1,
    numberOfParameters: 2,
    parameters: [
      { id: 1, value: "", name: "string", code: "Search Value" },
      { id: 2, value: "", name: "string", code: "New Value" },
    ],
  },
  // {
  //   name: "HexaToDecimal",
  //   displayedName: "HexaToDecimal",
  //   dataType: 1,
  //   returnDataType: 2,
  //   numberOfParameters: 1,
  //   parameters: [{ id: 1, value: "", name: "number" }],
  // },
  // {
  //   name: "Comp3ToDecimal",
  //   displayedName: "Comp3ToDecimal",
  //   dataType: 1,
  //   returnDataType: 2,
  //   numberOfParameters: 1,
  //   parameters: [{ id: 1, value: "", name: "number" }],
  // },
  // {
  //   name: "Comp2ToDecimal",
  //   displayedName: "Comp2ToDecimal",
  //   dataType: 1,
  //   returnDataType: 2,
  //   numberOfParameters: 1,
  //   parameters: [{ id: 1, value: "", name: "number" }],
  // },

  {
    name: "ToDate",
    displayedName: "ToDate",
    dataType: 1,
    returnDataType: 4,
    numberOfParameters: 1,
    parameters: [{ id: 1, value: "", name: "string", code: "Format" }],
  },
  {
    name: "ToDate",
    displayedName: "ToDate",
    dataType: 2,
    returnDataType: 4,
    numberOfParameters: 1,
    parameters: [{ id: 1, value: "", name: "string", code: "Value" }],
  },
  {
    name: "ToDate",
    displayedName: "ToDate",
    dataType: 4,
    returnDataType: 4,
    numberOfParameters: 1,
    parameters: [{ id: 1, value: "", name: "string", code: "Value" }],
  },
  {
    name: "StartOfMonth",
    displayedName: "StartOfMonth",
    dataType: 4,
    returnDataType: 4,
    numberOfParameters: 0,
    parameters: [],
  },
  {
    name: "EndOfTheMonth",
    displayedName: "EndOfTheMonth",
    dataType: 4,
    returnDataType: 4,
    numberOfParameters: 0,
    parameters: [],
  },
  {
    name: "Today",
    displayedName: "Today",
    dataType: 4,
    returnDataType: 4,
    numberOfParameters: 0,
    parameters: [],
  },
  {
    name: "ElapsedYear",
    displayedName: "ElapsedYear",
    dataType: 4,
    returnDataType: 2,
    numberOfParameters: 1,
    parameters: [{ id: 1, value: "", name: "string", code: "End Year" }],
  },
  {
    name: "ElapsedMonth",
    displayedName: "ElapsedMonth",
    dataType: 4,
    returnDataType: 2,
    numberOfParameters: 1,
    parameters: [{ id: 1, value: "", name: "string", code: "EndMonth" }],
  },
  {
    name: "ElapsedDay",
    displayedName: "ElapsedDay",
    dataType: 4,
    returnDataType: 2,
    numberOfParameters: 1,
    parameters: [{ id: 1, value: "", name: "string", code: "EndDay" }],
  },
  {
    name: "Age",
    displayedName: "Age",
    dataType: 4,
    returnDataType: 2,
    numberOfParameters: 0,
    parameters: [],
  },
  {
    name: "AgeAsOn",
    displayedName: "AgeAsOn",
    dataType: 4,
    returnDataType: 2,
    numberOfParameters: 1,
    parameters: [{ id: 1, value: "", name: "string", code: "Date" }],
  },
];

export default functionList;
